import PropTypes from 'prop-types'

const DecisionIcon = ({ className }: { className: string }) => (
  <svg width={48} height={48} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" className={className}>
    <title>{'Builder/ Operation/ Boolean'}</title>
    <path
      d="M37.561 20.899a1 1 0 001.053-.108l9-7a1 1 0 000-1.58l-9-7A1 1 0 0037 5.999v5H24a2 2 0 00-1.48.655l-9.405 10.345H2a2 2 0 100 4h11.115l9.4 10.345a2 2 0 001.485.655h13v5a1 1 0 001.614.79l9-7a1 1 0 000-1.58l-9-7a1 1 0 00-1.614.79v5H24.885l-8.185-9 8.182-9H37v5a1 1 0 00.561.9z"
      fill="#1A56DB"
      fillRule="nonzero"
    />
  </svg>
)

DecisionIcon.displayName = 'DecisionIcon'

DecisionIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

DecisionIcon.defaultProps = {
  className: '',
  onClick: () => {},
  title: 'App Builder'
}

export default DecisionIcon
